import { createContext } from 'react';

export const TenantContext = createContext({
  tenant: null,
  loading: true,
  reload: async () => {},
});
